

export interface UpGradCourse {
    "Modified Date": string
    "Created Date": string
    "Created By": string
    "course_type": string
    "destination_country": string
    "on_campus_currency": string
    "on_campus_duration": number
    "on_campus_fee": number
    "online_currency": string
    "online_duration": number
    "online_fee": number
    "university_name": string
    "_id": string
}

export const DEFAULT_UPGRAD_COURSE: UpGradCourse = {
    "Modified Date": '',
    "Created Date": '',
    "Created By": '',
    "course_type": '',
    "destination_country": '',
    "on_campus_currency": 'USD',
    "on_campus_duration": 0,
    "on_campus_fee": 0,
    "online_currency": '',
    "online_duration": 0,
    "online_fee": 0,
    "university_name": '',
    "_id": '',
}